import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { Divider } from '../../styles';
import { CustomerInformation } from '../../interfaces/Cart';
import TMarkUp from '../TMarkUp';

const DetailsSection = styled.div`
  padding: 1.5rem 0;

  h3 {
    margin-bottom: 1.25rem;
  }
`;

const DetailsAlSulaiman: React.FC<CustomerInformation> = ({
  firstName,
  lastName,
  addressFieldInfo,
  city,
  state,
  email,
  phoneNumber,
}): JSX.Element => {
  const { t } = useTranslation();

  let formattedAddress = '';
  if (typeof addressFieldInfo === 'string') {
    formattedAddress = addressFieldInfo;
  } else if (Array.isArray(addressFieldInfo)) {
    formattedAddress = addressFieldInfo.filter(Boolean).join(' ');
  }
  return (
    <>
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp value={t('spareParts.summary.delivery.title')} />
        </h3>
        <div
          aria-label={`Name: ${firstName} ${lastName}`}
        >{`${firstName} ${lastName}`}</div>
        <div aria-label={`Address: ${formattedAddress}`}>
          {formattedAddress}
        </div>
        <div>{`${city}`}</div>
        {state && <div>{`${state}`}</div>}
      </DetailsSection>
      <Divider />
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp
            value={t('spareParts.summary.delivery.contactInformation')}
          />
        </h3>
        <div aria-label={`Email: ${email}`}>{email}</div>
        <div aria-label={`Phone Number: ${phoneNumber}`}>{phoneNumber}</div>
      </DetailsSection>
    </>
  );
};
export default DetailsAlSulaiman;
